<script setup lang="ts">
import { ref } from 'vue';
import { LinkButton } from '@hfc/ui-core';
import { UUID } from '@hfc/common/src/types/UUID';
import SaveAndExitModal from '@/application/shared/infrastructure/components/SaveAndExitModal.vue';
import ClearAndRestartModal from '@/shared/infrastructure/components/ClearAndRestartModal.vue';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessStore } = useSmallBusinessStore();

interface PropsInterface {
  showSaveAndExit: boolean;
  showClearAndRestart: boolean;
  applicationType: string;
  uuid: UUID;
  email?: string;
  application: unknown;
  saveAndExitCallback?: (email: string) => Promise<void>;
}

defineProps<PropsInterface>();

interface EmitsInterface {
  (event: 'resetSection'): void;
}

const emits = defineEmits<EmitsInterface>();

const showSaveAndExitModal = ref(false);

function clearAndRestart (): void {
  smallBusinessStore.clearAndRestart();
  emits('resetSection');
}
</script>

<template>
  <div class="flex flex-col">
    <LinkButton v-if="showSaveAndExit" @click="showSaveAndExitModal = true">Save and Exit</LinkButton>
    <SaveAndExitModal v-if="showSaveAndExitModal" @close="showSaveAndExitModal = false" :email="email" :application-type="applicationType" :uuid="uuid" :application="application" :callback="saveAndExitCallback" />
    <ClearAndRestartModal v-if="showClearAndRestart" @confirm="clearAndRestart()" />
  </div>
</template>
